import actionCreatorFactory from 'typescript-fsa';

const ac = actionCreatorFactory();

export default {
  getQuestions: ac<number>('getQuestions'),
};
